import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';
import StyleTwoSectionTitle from './StyleTwoSectionTitle'
import StyleTwoCurriculumItem from './StyleTwoCurriculumItem'

export class StyleTwoCurriculum extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    let { itemsData, onMeiQiaCustomer } = this.props;
    return (
      <div className="topic-style-two-curriculum">
        <a name={itemsData.name}><StyleTwoSectionTitle isColorW={false} Data={itemsData} /></a>
        <div className='curriculum_section_background_box' style={{background: `url(${itemsData.totalbackImg}) no-repeat`}}>
          <div className='curriculum_section_box'>
            {itemsData.list && itemsData.list.map(item => <StyleTwoCurriculumItem Data={item} onMeiQiaCustomer={onMeiQiaCustomer} key={item.id} />)}
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoCurriculum);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoCurriculum.js